// Turn the flat group list (each with Parent_Group_ID) into a nested tree.
// Roots = groups whose parent is null OR whose parent is not in the visible set.
export function buildTree(groups) {
  const byId = new Map();
  groups.forEach((g) => byId.set(g.Group_ID, { ...g, children: [] }));

  const roots = [];
  byId.forEach((node) => {
    const parent = node.Parent_Group_ID ? byId.get(node.Parent_Group_ID) : null;
    if (parent) parent.children.push(node);
    else roots.push(node);
  });

  const sortRec = (nodes) => {
    nodes.sort((a, b) => a.Name.localeCompare(b.Name));
    nodes.forEach((n) => sortRec(n.children));
  };
  sortRec(roots);
  return roots;
}
